/** @module builtins/Math */

/**
 * Extend the Math class with a rounding function that allows for specifying the precision.
 * @param {Number} number - The number to round.
 * @param {Number} precision - The precision to round to, or 0 if unspecified.
 * @returns {Number} The rounded number.
 */
Object.defineProperty(Math, 'pround', {
    value: function (number, precision) {
        const power = 10 ** precision;
        return Math.round(number * power) / power;
    },
});

/**
 * Extend the Math class with a summing function.
 * @param {...Number} numbers - The numbers to sum. Any arrays are summed recursively.
 * @returns {Number} The sum of the numbers.
 */
Object.defineProperty(Math, 'sum', {
    value: function (...numbers) {
        return numbers.reduce((p, c) => p + (Array.isArray(c) ? Math.sum(...c) : c), 0);
    },
});
